import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/hooks/useAuth';
import PublicNavigation from '../../shared/components/layout/PublicNavigation';
import Navigation from '../../components/layout/Navigation';
import Footer from '../../shared/components/layout/Footer';

/**
 * Landing page (homepage).
 * Shows public content for unauthenticated users.
 * Shows authenticated navigation for logged-in users.
 */
const LandingPage: React.FC = () => {
  const { user } = useAuth();

  // If user is logged in, show authenticated navigation and redirect to home
  if (user) {
    return (
      <div className="bg-white min-h-screen flex flex-col">
        <Navigation />
        {/* Hero Section */}
        <div className="relative overflow-hidden flex-grow flex items-center justify-center">
          <div className="absolute inset-0 bg-gradient-to-r from-green-50 to-green-100 opacity-50" />
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
            <div className="text-center">
              <div className="flex justify-center mb-6">
                <img
                  src="/Vester-logo-lrg-clr.png"
                  alt="Vester"
                  className="h-24 sm:h-32 md:h-40 w-auto"
                />
              </div>
              <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
                <span className="block text-blk-600">Get rich together</span>
              </h1>
              <p className="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
                An antisocial network to track investments, learn together, and share strategies with close friends and family—all while keeping your dollar values private.
              </p>
              <div className="mt-5 max-w-md mx-auto sm:flex sm:justify-center md:mt-8">
                <div className="rounded-md shadow">
                  <Link
                    to="/portfolio"
                    className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-green-600 hover:bg-green-700 md:py-4 md:text-lg md:px-10"
                  >
                    Go to Portfolio
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Link to About page */}
        <div className="py-8 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <Link
              to="/about"
              className="text-green-600 hover:text-green-500 font-medium"
            >
              Learn more about Vester →
            </Link>
          </div>
        </div>

        <Footer />
      </div>
    );
  }

  // Unauthenticated users see public landing page
  return (
    <div className="bg-white">
      <PublicNavigation />
      
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-green-50 to-green-100 opacity-50" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="text-center">
            <div className="flex justify-center mb-6">
              <img
                src="/Vester-logo-lrg-clr.png"
                alt="Vester"
                className="h-24 sm:h-32 md:h-40 w-auto"
              />
            </div>
            <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
              <span className="block text-blk-600">Get rich together</span>
            </h1>
            <p className="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
              An antisocial network to track investments, learn together, and share strategies with close friends and family—all while keeping your dollar values private.
            </p>
            <div className="mt-5 max-w-md mx-auto sm:flex sm:justify-center md:mt-8">
              <div className="rounded-md shadow">
                <Link
                  to="/beta-request"
                  className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-green-600 hover:bg-green-700 md:py-4 md:text-lg md:px-10"
                >
                  Sign up for the Beta
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Link to About page */}
      <div className="py-8 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Link
            to="/about"
            className="text-green-600 hover:text-green-500 font-medium"
          >
            Learn more about Vester →
          </Link>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage;
